// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Sonic Universe - Aliens Configuration
 * 
 * IMPORTANT: This file only contains the planet-to-alien mapping.
 * All alien definitions are in src/config/AlienSpeciesConfig.js
 * 
 * Workflow:
 * 1. Add alien to AlienSpeciesConfig.js first
 * 2. Then map it to planets here
 */

export const SonicUniverseAliensPlanets = {
  planets: {
    // Green Hill Zone encounters
    2000: ['badnik_motobug', 'flicky_bird', 'chao_neutral'],
    
    // Chemical Plant Zone encounters
    2001: ['badnik_buzzer', 'badnik_motobug'],
    
    // Casino Night Zone encounters
    2002: ['badnik_buzzer', 'chao_neutral'],
    
    // Sky Sanctuary Zone encounters
    2003: ['badnik_buzzer'],
    
    // Angel Island Zone encounters
    2004: ['badnik_motobug', 'badnik_buzzer', 'chao_neutral', 'flicky_bird']
  },
  randomEncounters: ['badnik_motobug', 'badnik_buzzer'],
  hostileSpecies: ['badnik_motobug', 'badnik_buzzer'],
  friendlyTraders: ['chao_neutral', 'flicky_bird']
};

export default SonicUniverseAliensPlanets;